import Motor from '../layouts/Motor';
const indexRoutes = [{ path: '/', component: Motor, exact: false }];

export default indexRoutes;
